module.exports = __webpack_public_path__ + "static/media/pv-by-night.cbbdf8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/pv-by-night.png
// module id = 1829
// module chunks = 0